module.exports = {
  apps: 'Apps',
  autoJobs: 'Auto Jobs',
  auditLog: 'Audit Log',
  companies: 'Companies',
  configUpdates: 'Config Updates',
  catalogs: 'Catalogs',
  callerId: 'CallerID Servers',
  corporations: 'Corporations',
  domains: 'Domains',
  languageMappings: 'Language Mappings',
  licenses: 'Licenses',
  licenseReports: 'License Reports',
  webshopusageReports: 'Webshopusage Reports',
  model: 'Model',
  printTemplates: 'Print Templates',
  manufacturer: 'Manufacturer',
  discounts: 'Discounts',
  domain: 'Domain',
  moonBackup: 'Moon Backup',
  moonInstances: 'Moon Instances',
  systemlog: 'System Logs',
  system: 'System',
  tables: 'Tables',
  tableName: 'Table Name',
  tableCategory: 'Table Category Name',
  tableCategories: 'Table Categories',
  webShops: 'Web Shops',
  webspace: 'Web Spaces',
  accounts: 'Accounts',
  printers: 'Printers',
  printServers: 'Print Servers',
  login: 'Login',
  logout: 'Logout',
  emailConf: 'Email Configuration Settings',
  pending: 'Pending Orders',
  lastPending: 'Last Pending Order',
  historyId: 'History ID',
  srNo: 'Sr No',
  orderIdSource: 'Order ID/Source',
  orderCode: 'Order Code',
  customerName: 'Customer Name',
  totalAmount: 'Total Amount',
  contactedOn: 'Last Contacted On',
  templateType: 'Template Type',
  templateName: 'Template Name',
  day: 'Day',
  start: 'Start',
  end: 'End',
  catalogVersion: 'Catalog Version',
  licenseType: 'License Type',
  licenseKey: 'License Key',
  moonInstName: 'Moon Instace Name',
  activationDate: 'Activation Date',
  expiryDate: 'Expiry Date',
  createdDate: 'Created Date',
  modifiedDate: 'Modified Date',
  limit: 'Limit',
  callerIdName: 'CallerID Server Name',
  webShopResourceId: 'Web Shop Resource ID',
  noOfOrders: 'No Of Orders',
  ordersSum: 'Orders Sum',
  prefixLines: 'Prefix Lines',
  postixLines: 'Postfix Lines',
  jobName: 'Job Name',
  jobDesc: 'Job Description',
  lastExec: 'Last Executed On',
  nextExec: 'Next Planned Execution On',
  fromMiles: 'From Miles',
  toMiles: 'To Miles',
  charges: 'Charges',
  defaultCharges: 'Default Charges',
  fromAmount: 'From Amount',
  toAmount: 'To Amount',
  action: 'Action',
  sourceVersion: 'Source/Version',
  createdBy: 'Created By',
  synched: 'Synched On',
  instanceName: 'Instance Name',
  conditions: 'Conditions',
  values: 'Values',
  callerIdServers: 'CallerID Servers',
  webShopResource: 'Web Shop Resources',
  catalogName: 'Catalog Name',
  emailPhone: 'Email/Phone',
  webshop: 'webshop',
  orderingApp: 'ordering app',
  pricingInvoices: 'Invoices',
  pricingGroupName: 'Pricing Group Name',
  resourceTracking: 'Resource Tracking',
  resourceType: 'Resource Type/ID',
  trackingAction: 'Tracking Action',
  closedReason: 'Closed/Reason For Closure',
  cashRegister: 'Cash Register',
  htmlHints: 'Html Hints',
  images: 'Images',
  label: 'Label',
  companyGeneralData: 'Company General Data',
  companySettings: 'Company Settings',
  companyAddress: 'Company Address',
  properties: 'Properties',
  paymentSummary: 'Payment Summary',
  paymentType: 'Payment Type',
  amount: 'Amount',
  paymentGatewaySettings: 'Payment Gateway Settings',
  paymentTerminals: 'Payment Terminals',
  paymentServers: 'Payment Servers',
  delivery: 'Delivery',
  keys: 'Keys',
  automatedPrinting: 'Automated printing',
  fromMeters: 'From Meters',
  toMeters: 'To Meters',
  companyInfo: 'Company Info',
  account: 'Account',
  roleManagement: 'Role Management',
  originalVersion: 'Original version',
  views: 'Views',
  allergens: 'Allergens',
  massAddRemove: 'Mass Add/Remove',
  items: 'Items',
  edit: 'Edit',
  add: 'Add',
  item: 'Item',
  printerCategories: 'Printer categories',
  abbreviation: 'Abbreviation',
  name: 'Name',
  description: 'Description',
  sizes: 'Sizes',
  variants: 'Variants',
  options: 'Options',
  styles: 'Styles',
  settings: 'Settings',
  color: 'Color',
  language: 'Language',
  default: 'Default',
  actions: 'Actions',
  massTranslate: 'Mass translate',
  overwriteOptions: 'To overwrite',
  abbrevation: 'Abbrevation',
  taxCategory: 'Tax category',
  courseNo: 'Course No',
  vat: 'VAT'
};



// WEBPACK FOOTER //
// ./src/lang/en/header.js